import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=2cef27b8&scoped=true&"
import script from "./DeliveryForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=2cef27b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef27b8",
  null
  
)

export default component.exports